<form nz-form [formGroup]="validateForm" (ngSubmit)="submitForm()" class="share-form" nzLayout="vertical">
  <nz-form-item>
    <nz-form-label nzRequired nzFor="recipientName">Recipient Name</nz-form-label>
    <nz-form-control nzErrorTip="Please enter the recipient's name!">
      <input nz-input formControlName="recipientName" id="recipientName" placeholder="e.g. John Doe" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzRequired nzFor="recipientEmail">Recipient Email</nz-form-label>
    <nz-form-control nzErrorTip="Please enter a valid recipient email address!">
      <input nz-input formControlName="recipientEmail" id="recipientEmail" placeholder="e.g. name@example.com" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label nzFor="message">Personal Message (Optional)</nz-form-label>
    <nz-form-control>
      <textarea nz-input formControlName="message" id="message" [nzAutosize]="{ minRows: 3, maxRows: 6 }" placeholder="Add a personal note to the recipient..."></textarea>
    </nz-form-control>
  </nz-form-item>

  <div class="modal-footer">
    <button nz-button type="button" (click)="handleCancel()" [disabled]="loading">Cancel</button>
    <button nz-button nzType="primary" [nzLoading]="loading">Share Ticket</button>
  </div>
</form>
